import React, { useState, useEffect } from "react";
import { BeatLoader } from "react-spinners";
const API_search =
  "https://api.openweathermap.org/data/2.5/weather?units=metric&APPID=f5dcd30d77da5a621f1e83fead4e9488&q=";

function App() {
  const [query, setQuery] = useState("");
  const [weather, setWeather] = useState({});
  const [loading, setLoading] = useState(true);

  const getWeather = (APII) => {
    try {
      fetch(APII)
        .then((res) => res.json())
        .then((result) => {
          setWeather(result);
          setLoading(false);
        });
    } catch (e) {
      console.log(e);
    }
  };

  const search = (evt) => {
    if (evt.key === "Enter") {
      getWeather(API_search + query);
      setQuery("");
    }
  };
  useEffect(() => {
    getWeather(API_search + "cairo");
  }, []);

  const dateBuilder = (d) => {
    let months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    let days = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];

    let day = days[d.getDay()];
    let date = d.getDate();
    let month = months[d.getMonth()];
    let year = d.getFullYear();

    return `${day} ${date} ${month} ${year}`;
  };
  if (loading) {
    return (
      <div className="spinner">
        <BeatLoader color="#007bff" size={35} />
      </div>
    );
  } else {
    return (
      <div
        className={
          typeof weather.main != "undefined"
            ? weather.main.temp > 16
              ? "app warm"
              : "app"
            : "app"
        }
      >
        <main>
          <div className="search-box">
            <input
              type="text"
              className="search-bar"
              placeholder="Search..."
              onChange={(e) => setQuery(e.target.value)}
              value={query}
              onKeyPress={search}
            />
          </div>

          {typeof weather.main != "undefined" ? (
            <div>
              <div className="location-box">
                <div className="location">
                  {weather.name}, {weather.sys.country}
                </div>
                <div className="date">{dateBuilder(new Date())}</div>
              </div>
              <div className="weather-box">
                <div className="temp">{Math.round(weather.main.temp)}°c</div>
                <div className="weather">
                  {weather.weather[0].main},{weather.weather[0].description}
                </div>
              </div>
            </div>
          ) : (
            <div className="error">Sorry Your Search Did Not Match</div>
          )}
        </main>
      </div>
    );
  }
}

export default App;
